up.macro('div.mdc-snackbar', (element: HTMLElement) => {
    //const snackbarInstance = new snackbar.MDCSnackbar(element);

    //const _originalOpen = snackbarInstance.open;

    //snackbarInstance.open = async function () {
    //    const originalParent = element.parentElement;
    //    document.body.appendChild(element);

    //    _originalOpen.apply(snackbarInstance);

    //    setTimeout(() => {
    //        originalParent.appendChild(element);
    //    }, snackbarInstance.timeoutMs);
    //};

    //element['MDCSnackbar'] = snackbarInstance;

    //if (element.classList.contains("mdc-snackbar--autoshow")) {
    //    snackbarInstance.open();
    //}

    //return () => {
    //    element['MDCSnackbar'] = null;
    //    snackbarInstance.destroy();
    //};
});